import { createContext, useContext } from "react";

/**
 * 頂列上「頁面標題」那一格。
 *
 * 標題與副標由**頁面**提供（副標常常帶著即時資料，例如「共 10 筆」），但要
 * 顯示在**外殼**的頂列上 —— 資料的來源與顯示的位置在元件樹的兩端。
 *
 * 解法是外殼在頂列留一個空的 DOM 節點放進 context，頁面的 `PageHeader` 用
 * portal 把標題畫進去。這樣：
 *
 *   - 頂列永遠存在，全站控制項（深淺色、帳號）不會因為某一頁忘了寫標題而消失
 *   - 標題與副標只在 `PageHeader` 宣告一次，沒有第二份要同步的狀態
 *   - 沒有用 useEffect 往上寫狀態 —— 那種寫法會多一次 render 才畫出標題，
 *     切頁時看得到標題閃一下
 *
 * 沒有 provider 或節點還沒掛上時是 null，`PageHeader` 就只畫頁內那一段，
 * 不會壞掉。
 */
const PageTitleSlotContext = createContext<HTMLElement | null>(null);

export const PageTitleSlotProvider = PageTitleSlotContext.Provider;

export function usePageTitleSlot(): HTMLElement | null {
  return useContext(PageTitleSlotContext);
}
